import dynamic from "next/dynamic";

export const Tip = dynamic(() => import("./component"));
